var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60879 15.2176C11.811 15.2176 15.2176 11.811 15.2176 7.60879C15.2176 3.40657 11.811 0 7.60879 0C3.40657 0 0 3.40657 0 7.60879C0 11.811 3.40657 15.2176 7.60879 15.2176ZM7.60879 14.2031C11.2507 14.2031 14.2031 11.2507 14.2031 7.60879C14.2031 3.96687 11.2507 1.01451 7.60879 1.01451C3.96687 1.01451 1.01451 3.96687 1.01451 7.60879C1.01451 11.2507 3.96687 14.2031 7.60879 14.2031ZM16.9081 17.6254L13.7733 14.4906L13.5472 14.2646C13.3492 14.0665 13.3492 13.7453 13.5472 13.5472C13.7453 13.3492 14.0665 13.3492 14.2646 13.5472L14.4906 13.7733L17.6254 16.9081L17.8514 17.1341C18.0495 17.3322 18.0495 17.6533 17.8514 17.8514C17.6533 18.0495 17.3322 18.0495 17.1341 17.8514L16.9081 17.6254Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1856_2844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60879 15.2176C11.811 15.2176 15.2176 11.811 15.2176 7.60879C15.2176 3.40657 11.811 0 7.60879 0C3.40657 0 0 3.40657 0 7.60879C0 11.811 3.40657 15.2176 7.60879 15.2176ZM7.60879 14.2031C11.2507 14.2031 14.2031 11.2507 14.2031 7.60879C14.2031 3.96687 11.2507 1.01451 7.60879 1.01451C3.96687 1.01451 1.01451 3.96687 1.01451 7.60879C1.01451 11.2507 3.96687 14.2031 7.60879 14.2031ZM16.9081 17.6254L13.7733 14.4906L13.5472 14.2646C13.3492 14.0665 13.3492 13.7453 13.5472 13.5472C13.7453 13.3492 14.0665 13.3492 14.2646 13.5472L14.4906 13.7733L17.6254 16.9081L17.8514 17.1341C18.0495 17.3322 18.0495 17.6533 17.8514 17.8514C17.6533 18.0495 17.3322 18.0495 17.1341 17.8514L16.9081 17.6254Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1856_2844)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eae5caf2f1c402ea9cd6e8cd9b9767a2.svg";
export { ForwardRef as ReactComponent };